import {useCallback} from 'react';
import paper from 'paper';
import opentype from 'opentype.js';
import {clearSelection} from './paper-system-utils';

export function useTextTool({setActiveTool, onProjectChange, updateTransformUI, viewMode}) {
  return useCallback(
    (point) => {
      if (!paper.project) return;
      
      const textItem = new paper.PointText({
        point,
        content: 'Text',
        fillColor: '#888',
        strokeColor: '#888',
        strokeWidth: 1.5,
        fontSize: 30,
        fontFamily: 'Arial',
        data: {
          fontFamily: 'Arial',
        }
      });

      if (viewMode === 'vector') {
        textItem.data.origStyle = {
          fillColor: '#888',
          strokeColor: '#888',
          strokeWidth: 1.5,
          strokeScaling: textItem.strokeScaling
        };
        textItem.fillColor = new paper.Color(0, 0, 0, 0.001);
        textItem.strokeColor = '#cbd5e1';
        textItem.strokeWidth = 1 / paper.view.zoom;
        textItem.strokeScaling = false;
      }

      textItem.name = 'New Text';
      textItem.content = ''; //
      
      clearSelection();
      textItem.selected = true;
      window.dispatchEvent(new CustomEvent('paper-item-transform'));
      updateTransformUI();
      

      setActiveTool?.('select');
      onProjectChange?.();
      
      setTimeout(() => {
        const event = new CustomEvent('edit-text-item', { detail: { item: textItem } });
        window.dispatchEvent(event);
      }, 50);
    },
    [setActiveTool, onProjectChange, updateTransformUI, viewMode]
  );
}